import { Component } from '@angular/core';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';

interface RoomingListI {
	name: string;
	version: string;
	params: {
		date: string;
		location: string;
	};
	output_params: {
		name: string;
		kind: string;
		sheetName: string;
		path: string;
	};
}

interface RoomingListLocationI {
	id: number;
	name: string;
	href: string;
}

@Component({
	selector: 'app-accommodation-generate',
	templateUrl: './accommodation-generate.component.html',
	styleUrls: ['./accommodation-generate.component.scss'],
})
export class AccommodationGenerateComponent {
	constructor(
		private readonly infobox: InfoboxService,
		private readonly httpClient: HttpClient,
		private readonly formBuilder: FormBuilder,
		private readonly datePipe: DatePipe,
	) {}

	readonly roomingListLocations: { [key: string]: RoomingListLocationI } = {
		croatia: {
			id: 11,
			name: 'Chorwacja',
			href: 'https://docs.google.com/spreadsheets/d/1v5cOMD6BOl3eF9xx4D51u1IRfRBBqOfpcWrQ-hmXIgQ/edit#gid=0',
		},
		paralia: {
			id: 143,
			name: 'Paralia',
			href: 'https://docs.google.com/spreadsheets/d/1QMX73ZfXyZ36Qwb6C6AphP87FDcPSvQ5iKgTZb2FpSE/edit#gid=0',
		},
		prague: {
			id: 485,
			name: 'Praga',
			href: 'https://docs.google.com/spreadsheets/d/1_GCcSzHuViCyxeVPXdrlhylVCE8IrBUYF3eIE9Iz43M/edit#gid=0',
		},
		montenegro: {
			id: 12,
			name: 'Czarnogóra',
			href: 'https://docs.google.com/spreadsheets/d/14EZ2j_f76WV2MMc8uM6pPFshdnB2s3jNYvwdDV_IiZo/edit#gid=0',
		},
		bulgaria: {
			id: 10,
			name: 'Bułgaria',
			href: 'https://docs.google.com/spreadsheets/d/1NXA7yFQCdAoQiwbwXju_Z6960zdzQpkLHiBo14EBD3U/edit?gid=0#gid=0',
		},
		albania: {
			id: 4,
			name: 'Albania',
			href: 'https://docs.google.com/spreadsheets/d/1tuRVC_2ZYREN4JJ7TcoHcduLdhJC6-GMzSpgsUo-e74/edit?gid=0#gid=0',
		},
	};

	formGroup: FormGroup = this.formBuilder.group({
		forDate: ['', Validators.required],
		destination: [this.roomingListLocations.croatia, Validators.required],
	});

	generateRL(): void {
		this.formGroup.markAllAsTouched();

		if (this.formGroup.invalid) {
			return;
		}

		const formatedDate = this.datePipe.transform(this.formGroup.get('forDate').value, 'yyyy-MM-dd');
		const destination = this.formGroup.get('destination').value;

		const reportData = {
			name: 'RoomingListAccommodationReport',
			version: 'v1',
			params: {
				date: formatedDate,
				location: destination.id,
			},
			output_params: {
				name: `${destination.name}-RL`,
				kind: 'Google Drive',
				sheetName: 'DATA',
				path: `Reports/RL_ERP`,
			},
		};

		this.createRLReport(reportData);
	}

	private createRLReport(reportData: RoomingListI): void {
		this.httpClient.post(`${environment.apiUrl}/report/`, reportData).subscribe((report) => {
			if (report) {
				this.infobox.success('Zapisano pomyślnie. Generowanie rozpocznie się za chwilę');
			}
		});
	}
}
